import type { ExperimentFormData } from "../types/experiment.types";

export const CONTEXT_NAME_MIN_LENGTH = 3;
export const CONTEXT_GOAL_MIN_LENGTH = 20;
export const CONTEXT_DESCRIPTION_MIN_LENGTH = 30;

export interface ContextStepValidationResult {
  isValid: boolean;
  missingFields: string[];
  errors: Record<string, string>;
}

export const getContextValidationErrors = (
  experimentData: Pick<
    ExperimentFormData,
    "name" | "goal" | "description"
  >,
): Record<string, string> => {
  const errors: Record<string, string> = {};

  const name = experimentData.name?.trim() ?? "";
  if (!name) {
    errors.name = "Experiment name is required.";
  } else if (name.length < CONTEXT_NAME_MIN_LENGTH) {
    errors.name = `Experiment name should be at least ${CONTEXT_NAME_MIN_LENGTH} characters.`;
  }

  const goal = experimentData.goal?.trim() ?? "";
  if (!goal) {
    errors.goal = "Business goal is required.";
  } else if (goal.length < CONTEXT_GOAL_MIN_LENGTH) {
    errors.goal = `Business goal should be at least ${CONTEXT_GOAL_MIN_LENGTH} characters.`;
  }

  const description = experimentData.description?.trim() ?? "";
  if (!description) {
    errors.description = "Context is required.";
  } else if (description.length < CONTEXT_DESCRIPTION_MIN_LENGTH) {
    errors.description = `Context should be at least ${CONTEXT_DESCRIPTION_MIN_LENGTH} characters.`;
  }

  return errors;
};

export const validateContextStep = (
  experimentData: Pick<
    ExperimentFormData,
    "name" | "goal" | "description"
  >,
): ContextStepValidationResult => {
  const errors = getContextValidationErrors(experimentData);
  const missingFields = Object.keys(errors).map((field) =>
    field === "description"
      ? "context & background"
      : field === "goal"
        ? "business goal"
        : "experiment name",
  );

  return {
    isValid: missingFields.length === 0,
    missingFields,
    errors,
  };
};
